import { STATE_VERSION, initialSummaryFeedback } from '../constants.js'
import { createInitialContext } from '../engine/engine.js'

export function createInitialState(month) {
  return {
    version: STATE_VERSION,
    stage: 'experience',
    experience: 'beginner',
    context: createInitialContext(month),
    observations: {},
    history: [],
    currentQuestionId: null,
    feedback: { questions: {}, summary: { ...initialSummaryFeedback } },
    lastMessage: '',
  }
}

export function guidedObservationReducer(state, action) {
  switch (action.type) {
    case 'SET_EXPERIENCE': return { ...state, experience: action.value, stage: action.advance ? 'context' : state.stage }
    case 'UPDATE_CONTEXT': return { ...state, context: action.value }
    case 'SET_CONTEXT': return { ...state, context: action.value, stage: action.questionId ? 'question' : 'summary', currentQuestionId: action.questionId }
    case 'RECORD': {
      const history = state.history.filter((id) => id !== action.questionId)
      return { ...state, observations: action.observations, history: [...history, action.questionId], currentQuestionId: action.nextQuestionId, stage: action.nextQuestionId ? 'question' : 'summary', lastMessage: action.message }
    }
    case 'EDIT': return { ...state, stage: 'question', currentQuestionId: action.questionId }
    case 'BACK': return { ...state, stage: action.stage || 'question', currentQuestionId: action.questionId ?? state.currentQuestionId }
    case 'SUMMARY': return { ...state, stage: 'summary' }
    case 'CONTINUE': return { ...state, stage: 'question', currentQuestionId: action.questionId }
    case 'QUESTION_FEEDBACK': return { ...state, feedback: { ...state.feedback, questions: { ...state.feedback.questions, [action.questionId]: action.value } } }
    case 'SUMMARY_FEEDBACK': return { ...state, feedback: { ...state.feedback, summary: { ...state.feedback.summary, [action.field]: action.value } } }
    case 'RESTART': return createInitialState(action.month)
    default: return state
  }
}
